import { render, staticRenderFns } from "./BaskoNextGenSidebar.vue?vue&type=template&id=77df2b01&scoped=true"
import script from "./BaskoNextGenSidebar.vue?vue&type=script&lang=js"
export * from "./BaskoNextGenSidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77df2b01",
  null
  
)

export default component.exports